import { styled } from 'theme'

export const StyledSentryErrorDialog = styled.div`
  padding: 1em;
  padding-left: 0;
`
